import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
export default ProtoBaseModel.extend({
  comboPriceAdjustmentMoney: attr(MoneyProto),
  comboAppliedMoney: attr(MoneyProto),
  comboAppliedWeight: attr(Number),
  appliedComboClientToken: attr(String),
  appliedComboChoiceId: attr(String),
  appliedComboChoiceName: attr(String)
});